import { render, staticRenderFns } from "./HeroOverlay.vue?vue&type=template&id=48fa122f&scoped=true&"
import script from "./HeroOverlay.vue?vue&type=script&lang=js&"
export * from "./HeroOverlay.vue?vue&type=script&lang=js&"
import style0 from "./HeroOverlay.vue?vue&type=style&index=0&id=48fa122f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa122f",
  null
  
)

export default component.exports